import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Dropdown } from 'react-bootstrap';
import SignUpForUpdatesForm from './SignUpForUpdatesForm'
import Nav from './nav';

const Header = ({ settings }) => {

  console.log('header settings', settings.SITE_COMING_SOON_MODE.value);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const closeModal = () => {
    setSideNav(false);
  };
  
  return (
    <div>
      <div id='preloader'></div>
      <div id='headerBar'>
        <div className='herzogLogo'>
          <span>A Product of</span>
          <Link href={'https://herzogfoundation.com'} >
            <Image
              src='/img/home/logo_herzog_top.svg'
              width={170}
              height={20}
              alt='Shcool Top Logo'
            />
          </Link>
        </div>
        <div id='headerAccount'>
          { settings.SITE_COMING_SOON_MODE.value == 'false' &&
            <Link href='/signin'>
              <a>
                <i className='far fa-user-circle'></i> My Account
              </a>
            </Link>
          }
        </div>
      </div>

      <header className='header'>
        <div id='headerLogo' className='animated fadeInDown'>
          <Link href='/'>
            <a>
              <img src='img/home/logo.svg' alt='SchoolBox Logo' />
            </a>
          </Link>
        </div>
        <nav className='animated fadeInLeft'>
          <Dropdown as='div' drop='down' className='header-dropdown'>
            <Dropdown.Toggle variant='success' id='toggle-menu'>
              <i className='fa fa-bars'></i>&nbsp; Menu
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item href='#about'>About</Dropdown.Item>
              <Dropdown.Item href='#whats-inside'>
                What&apos;s Inside
              </Dropdown.Item>
              <Dropdown.Item href='#eligibility'>Eligibility</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Nav />
        </nav>

        <div id='headerBtn' className='animated fadeInRight'>

          <a onClick={handleShow} className='button btn-outline-highlight'>Sign up for updates ›</a>

        </div>
        <SignUpForUpdatesForm
          show={show}
          handleClose={handleClose}
        />
      </header>
    </div>
  );
};

export default Header;
